import { useSyncExternalStore } from 'react';

export const LANGUAGES = [
  { id: 'java', label: 'Java', file: 'Solution.java', color: '#F97316' },
  { id: 'c', label: 'C', file: 'solution.c', color: '#3B82F6' },
  { id: 'cpp', label: 'C++', file: 'solution.cpp', color: '#A855F7' },
  { id: 'python', label: 'Python', file: 'solution.py', color: '#22C55E' },
];

const KEY = 'courseLanguage';
const EVT = 'course-language-change';

export const getLangInfo = (id) => LANGUAGES.find(l => l.id === id) || LANGUAGES[0];
export const getCourseLanguage = () => {
  const v = localStorage.getItem(KEY);
  return LANGUAGES.some(l => l.id === v) ? v : 'java';
};
export const setCourseLanguage = (id) => {
  localStorage.setItem(KEY, id);
  window.dispatchEvent(new Event(EVT));
};

const subscribe = (cb) => {
  window.addEventListener(EVT, cb);
  window.addEventListener('storage', cb);
  return () => {
    window.removeEventListener(EVT, cb);
    window.removeEventListener('storage', cb);
  };
};

export const useCourseLanguage = () => {
  const lang = useSyncExternalStore(subscribe, getCourseLanguage);
  return [lang, setCourseLanguage];
};

// Badge ids: Java course keeps legacy ids; other courses use `${base}--${lang}`
export const splitBadgeId = (id = '') => {
  const [base, lang] = id.split('--');
  return { base, lang: lang || 'java' };
};
export const badgeIdFor = (base, lang) => (lang === 'java' ? base : `${base}--${lang}`);
